// Target: src/modules/billing/components/formSections/BillingCombineOrdersFormSection.tsx
import type { Control, FieldValues } from "react-hook-form";

import FormSection from "~/components/formElements/FormSection";
import RadioGroup from "~/components/formElements/RadioGroup/RadioGroup";
import { PROJECT_BILLING_SETTINGS_COMBINE_ORDERS_OPTIONS } from "~/constants/form.ts";

type Props<T extends FieldValues> = {
	control: Control<T>;
};

interface BillingCombineOrdersFormData {
	combineOrders: boolean;
}

const BillingCombineOrdersFormSection = <T extends BillingCombineOrdersFormData>({
	control,
}: Props<T>) => {
	return (
		<FormSection title="Sammelrechnung für alle Phasen">
			<RadioGroup
				control={control}
				name="combineOrders"
				options={PROJECT_BILLING_SETTINGS_COMBINE_ORDERS_OPTIONS}
				numCols={2}
			/>
		</FormSection>
	);
};

export default BillingCombineOrdersFormSection;
